import * as React from "react";
import { useTranslation } from "react-i18next";
import { forwardRef, useContext } from "react";
import styled, { css } from "styled-components";
import zIndices from "theme/z-indices";
import Icon from "components/common/Icon";
import SortIcon from "components/common/EntityDataTable/SortIcon";
import {
  ThInner,
  LeftCol,
  IndicatorCol,
  DragIcon
} from "components/common/EntityDataTable/hooks/useAttributeColumnDefinitions";
import HeaderActionsDropdown from "components/common/EntityDataTable/HeaderActionsDropdown";
import ActiveSliceColContext from "components/common/EntityDataTable/contexts/ActiveSliceColContext";
const CustomDragOverlay = styled.div(
  ({ theme, $minWidth }) => css`
    background-color: ${theme.colors.global.contentBackground};
    z-index: ${zIndices.dropdownMenu};
    width: ${$minWidth}px;
    min-width: fit-content;
    white-space: nowrap;
    max-width: 300px;
    box-shadow:
      rgb(0 0 0 / 5%) 0 1px 3px 0,
      rgb(0 0 0 / 5%) 0 28px 23px -7px,
      rgb(0 0 0 / 4%) 0 12px 12px -7px;

    border-radius: 3px;
    border: 1px solid ${theme.colors.input.borderFocus};
    display: flex;
    align-items: stretch;
  `
);
const StyledDragIcon = styled(DragIcon)`
  top: -1px;
`;
const ActiveSliceIcon = styled(Icon)(
  ({ theme, $isRightAligned }) => css`
    display: inline-flex;
    ${$isRightAligned ? css`
          margin-right: ${theme.spacings.xs};
        ` : css`
          margin-left: ${theme.spacings.xs};
        `}
    color: ${theme.colors.text.secondary};
    cursor: default;
  `
);
const ThGhostInner = ({ column }, ref) => {
  var _a, _b, _c;
  const { t } = useTranslation("common");
  const activeSliceCol = useContext(ActiveSliceColContext);
  const columnMeta = (_a = column.columnDef) == null ? void 0 : _a.meta;
  const columnLabel = (_b = columnMeta == null ? void 0 : columnMeta.label) != null ? _b : column.id;
  const canSlice = columnMeta == null ? void 0 : columnMeta.enableSlicing;
  const canSort = column.getCanSort();
  const canHideColumn = column.getCanHide();
  const isSliceActive = Boolean(canSlice && activeSliceCol === column.id);
  const sortDirection = column.getIsSorted();
  const textAlign = (_c = columnMeta == null ? void 0 : columnMeta.columnRenderer) == null ? void 0 : _c.textAlign;
  const isRightAligned = textAlign === "right";
  const titleGroup = /* @__PURE__ */ React.createElement(LeftCol, null, /* @__PURE__ */ React.createElement(
    HeaderActionsDropdown,
    {
      textAlign,
      label: columnLabel,
      activeSort: sortDirection,
      isSliceActive,
      onChangeSlicing: canSlice ? () => {
      } : void 0,
      sliceColumnId: column.id,
      onSort: canSort ? () => {
      } : void 0,
      onHideColumn: canHideColumn ? () => {
      } : void 0
    },
    columnLabel
  ));
  const sliceIndicator = isSliceActive && /* @__PURE__ */ React.createElement(
    ActiveSliceIcon,
    {
      name: "surgical",
      title: t("entity_table.slicing_by", { column: columnLabel }),
      $isRightAligned: isRightAligned
    }
  );
  const sortIndicator = sortDirection && /* @__PURE__ */ React.createElement(SortIcon, { column });
  const indicatorIcons = /* @__PURE__ */ React.createElement(IndicatorCol, null, isRightAligned ? /* @__PURE__ */ React.createElement(React.Fragment, null, sortIndicator, sliceIndicator) : /* @__PURE__ */ React.createElement(React.Fragment, null, sliceIndicator, sortIndicator));
  return /* @__PURE__ */ React.createElement(CustomDragOverlay, { ref, $minWidth: column.getSize() }, /* @__PURE__ */ React.createElement(ThInner, null, /* @__PURE__ */ React.createElement(StyledDragIcon, { name: "drag_indicator", size: "xs", $isDragging: true }), isRightAligned ? /* @__PURE__ */ React.createElement(React.Fragment, null, indicatorIcons, titleGroup) : /* @__PURE__ */ React.createElement(React.Fragment, null, titleGroup, indicatorIcons)));
};
const ThDragOverlay = forwardRef(ThGhostInner);
export default ThDragOverlay;
